import React from "react";
import { useTranslation } from "react-i18next";
import {
    StyledH2,
    StyledLabel,
    StyledModal,
    StyledTextInput,
} from "@aureskonnect/react-ui";
import { ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { AvForm, AvGroup } from "availity-reactstrap-validation";

import { setIsEdited } from "./store";

import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";

import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";

export function SoftaveraPayConfig({
    isModalOpened,
    setIsModalOpened,
    rowData,
    publicAccountId,
    setPublicAccountId,
    apiKey,
    setApiKey,
    yavinId,
    setYavinId,
}: any) {
    const { t } = useTranslation();
    const [yavinIdLocal, setYavinIdLocal] = React.useState(yavinId);
    const [apiKeyLocal, setApiKeyLocal] = React.useState(apiKey);
    const [public_account_idLocal, setPublicAccountIdLocal] = React.useState(
        publicAccountId
    );
    function handleValidate() {
        setIsModalOpened(false);
        setYavinId(yavinIdLocal);
        setApiKey(apiKeyLocal);
        setPublicAccountId(public_account_idLocal);
    }

    return (
        <StyledModal
            toggle={true}
            isOpen={isModalOpened!}
            centered
            size="lg"
            scrollable
        >
            <ModalHeader
                className="text-capitalize"
                toggle={() => {
                    setIsModalOpened(false);
                }}
            >
                <StyledH2 className="mt-1">
                    {(
                        t("SoftaveraPay Configuration") +
                        " - " +
                        rowData[t("Shop")]
                    ).toUpperCase()}
                </StyledH2>
            </ModalHeader>
            <ModalBody>
                <AvForm>
                    <StyledLabel>
                        {t("Please fill in the following fields")}:
                    </StyledLabel>
                    <AvGroup>
                        <StyledLabel htmlFor="path" className="mt-3">
                            {t("Yavin ID")}:
                        </StyledLabel>
                        <StyledTextInput
                            name="yavin_id"
                            placeholder={t("Write")}
                            type="text"
                            autocomplete="off"
                            value={yavinIdLocal}
                            onChange={(e: any) => {
                                setYavinIdLocal(e.target.value);
                                setIsEdited(true);
                            }}
                        />
                    </AvGroup>
                    <AvGroup>
                        <StyledLabel htmlFor="path" className="mt-3">
                            {t("API key")}:
                        </StyledLabel>
                        <StyledTextInput
                            name="api_key"
                            placeholder={t("Write")}
                            type="text"
                            autocomplete="off"
                            value={apiKeyLocal}
                            onChange={(e: any) => {
                                setApiKeyLocal(e.target.value);
                                setIsEdited(true);
                            }}
                        />
                    </AvGroup>
                    <AvGroup>
                        <StyledLabel htmlFor="path" className="mt-3">
                            {t("Public account ID")}:
                        </StyledLabel>
                        <StyledTextInput
                            name="public_account_id"
                            placeholder={t("Write")}
                            type="text"
                            autocomplete="off"
                            value={public_account_idLocal}
                            onChange={(e: any) => {
                                setPublicAccountIdLocal(e.target.value);
                                setIsEdited(true);
                            }}
                        />
                    </AvGroup>
                </AvForm>
            </ModalBody>
            <ModalFooter className="border-top-0 ">
                <CustomSecondaryColorButton
                    outline
                    variant="light"
                    onClick={() => {
                        setIsModalOpened(false);
                    }}
                    rounded
                >
                    {t("Cancel")}
                </CustomSecondaryColorButton>
                <CustomMainColorButton
                    rounded
                    className="mr-2"
                    variant="primary"
                    onClick={handleValidate}
                >
                    {t("Validate")}
                </CustomMainColorButton>
            </ModalFooter>
        </StyledModal>
    );
}
